$ ->
  videoQuestion = undefined

  $(document).on 'initialize-feature-question', ->
    # Shuffles answers after wrong answer selected...
    jQuery.fn.shuffle = ->
      allElems = @get()
      getRandom = (max) ->
        Math.floor Math.random() * max

      shuffled = $.map(allElems, ->
        random = getRandom(allElems.length)
        randEl = $(allElems[random]).clone(true)[0]
        allElems.splice random, 1
        randEl
      )
      @each (i) ->
        $(this).replaceWith $(shuffled[i])
      $ shuffled

    # Question and answers on learner video page
    videoQuestion =
      setup: ->
        @$form = $("#video_response")
        @$answerIdFormField = $("#video_response_answer_id")
        @$answerList = $(".shared-feature-question__answers")
        @$resetButton = $(".try-again-link")
        @$submitButton = $(".submit-question")
        @$nextVideoButton = $('.next-video-button')
        @$popup = $(".app-popup-warning")
        $("li", @$answerList).shuffle()
        @$correctAnswerFeedback = $(".banner-feedback--approved")
        @$wrongAnswerFeedback = $(".banner-feedback--warning")
        $(".is-correct", @$answerList).removeClass "is-correct"
        $(".is-wrong", @$answerList).removeClass "is-wrong"
        @$answerIdFormField.val ""
        @$answerList.addClass "is-enabled"
        @bindEvents()

      bindEvents: ->
        @$resetButton.unbind('click')
        @$resetButton.on 'click', (e) => @resetQuestion(e)
        @$submitButton.unbind('click')
        @$submitButton.on 'click', => @answerQuestion()

      answerQuestion: ->
        if $('#with-lead-non-free-test')[0]
          $('#with-lead-non-free-test').show()
        else
          $answer = $(".is-preselected")
          if typeof($answer[0]) == 'undefined'
            @$popup.show()
          else
            correct = $answer.hasClass("correct")
            $answer.addClass (if correct then "is-correct" else "is-wrong")
            (if correct then @$correctAnswerFeedback.show() else @$wrongAnswerFeedback.show())
            @$answerIdFormField.val $answer.attr("id")
            @$form.ajaxSubmit()
            $answer.parent().removeClass "is-enabled"
            @$resetButton.show()
            @$submitButton.hide()
            @$nextVideoButton.show()
            $('body').scrollTop(200)

      resetQuestion: ($event) ->
        $(".banner-feedback").hide()
        $('.is-preselected').removeClass('is-preselected')
        if $('#with-lead-free-video')[0]
          $("#with-lead-free-video").hide()
        @$resetButton.hide()
        @$submitButton.show()
        @$nextVideoButton.hide()
        videoQuestion.setup()
        $event.preventDefault()

    if $('.shared-feature-question')[0]
      videoQuestion.setup()

    $("#question-button").unbind('click')
    $("#question-button").on "click", ->
      if Sofatutor.player.videoJsLoaded()
        if Sofatutor.player.isVideoJs5()
          videojs.getPlayers()['player-0']?.exitFullscreen() if videojs.getPlayers()["player-0"]?.isFullscreen()
        else
          videojs.players['player-0']?.exitFullscreen() if videojs.players["player-0"]?.isFullscreen()

      $(".video-player, .video-sidebar").hide()
      videoQuestion.setup()
      $(".shared-feature-question").show()
      if Sofatutor.player.videoJsLoaded()
        if Sofatutor.player.isVideoJs5()
          if videojs.getPlayers()["player-0"]?.paused()
            playerWasPaused = true
          else
            playerWasPaused = false
            videojs.getPlayers()["player-0"]?.pause()
        else
          if videojs.players["player-0"]?.paused()
            playerWasPaused = true
          else
            playerWasPaused = false
            videojs.players["player-0"]?.pause()
      else
        $('#player-0').get(0).pause()

      $(document).trigger "questionShown"
      false

    $(".shared-feature-question").unbind('click')
    $(".shared-feature-question").on "click", ".shared-feature-question__answers.is-enabled li", ->
      if $(this).hasClass('is-preselected')
        $(this).removeClass('is-preselected')
      else
        $('.is-preselected').removeClass('is-preselected')
        $('.app-popup-warning').hide()
        $(document).trigger 'questionAnswered'
        $(this).addClass('is-preselected')
